import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-sm text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-2">
              {item.href && !isLast ? (
                <Link to={item.href} className="hover:text-primary-700 transition-colors cursor-pointer">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-400" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}